import { apiAxios } from '@/lib/apiAxios';
export const toggleTrackingLinkStatus = async ({ publicId, active }) => apiAxios
    .patch(`/tracking-links/${publicId}/status`, { active })
    .then((response) => response.data);
export const deleteTrackingLink = async ({ publicId }) => apiAxios
    .delete(`/tracking-links/${publicId}`)
    .then((response) => response.data);
export const putTrackingLink = async ({ publicId, data }) => {
    // Strip the local File before sending JSON — the image goes via uploadTrackingLinkImage.
    const { imageFile: _imageFile, ...rest } = data;
    return apiAxios
        .put(`/tracking-links/${publicId}`, rest)
        .then((response) => response.data);
};
export const uploadTrackingLinkImage = async ({ publicId, imageFile }) => {
    const formData = new FormData();
    formData.append('imageFile', imageFile);
    const response = await apiAxios.post(`/tracking-links/${publicId}/uploads`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
};
export const fetchEntryPoints = async (publicId) => apiAxios.get(`/tracking-links/${publicId}/entry-points`).then((response) => response.data);
export const postEntryPoint = async ({ publicId, data }) => apiAxios
    .post(`/tracking-links/${publicId}/entry-points`, data)
    .then((response) => response.data);
